<template>
  <div>
                  <v-flex xs12 sm6 d-flex class="pl-3">
          <v-text-field
            v-model="state.filter"
            flat
            :label="$t('Action.search')"
            append-icon="search"
            hide-details
            clearable
            style="padding-bottom: 20px"
            @change="setFilter"
            @click:clear="setFilter('')"
          ></v-text-field>
        </v-flex>
    <v-container fluid grid-list-md>
      <v-dialog v-model="details.visible"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar>
            <v-btn icon @click="closeDetails()">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{details.transactionnum}}</v-toolbar-title>
          </v-toolbar>
          <v-list three-line subheader>
            <v-data-table
                    :headers="cartHeaders"
                    :items="details.cart ? details.cart.items : []"
                    :rows-per-page-items="rowsPerPageItems"
                    must-sort
                    disable-initial-sort
                    hide-actions
                    class="elevation-1 mt-3"
                    @update:pagination="onUpdatePagination"
            >

              <template slot="headerCell" slot-scope="props">
                <span>{{ $t(props.header.text) }}</span>
              </template>

              <template slot="items" slot-scope="props">
                <td>{{ props.item.itemnum }}</td>
                <td>{{ props.item.name }}</td>
                <td class="text-xs-right">
                  {{ props.item.amount}}
                </td>
                <td class="text-xs-right">{{ props.item.taxrate.toLocaleString($i18n.locale) }}</td>
                <td class="text-xs-right">{{ props.item.sellingprice.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
                <td class="text-xs-right">{{ props.item.nettotal.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
              </template>

              <template slot="footer" v-if="details.cart && details.cart.items.length > 0">
                <td class="grey subheading"><strong>{{ $t('Common.total') }}</strong></td>
                <td class="grey"></td>
                <td class="grey"></td>
                <td colspan="2" class="grey text-xs-right caption">
                  <div>{{ $t('Common.netAmount')}} :</div>
                  <div>{{ $t('Common.taxAmount')}} :</div>
                  <div>{{ $t('Common.grossAmount')}} :</div></td>
                <td class="grey text-xs-right">
                  <div>{{ details.cart.netamount.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
                  <div>{{ details.cart.tax.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
                  <div>{{ details.cart.total.toLocaleString($i18n.locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
                </td>
              </template>

            </v-data-table>

          </v-list>
        </v-card>
      </v-dialog>

      <h1>{{ $t(`Application.${config.type}`) }}</h1>
      <v-data-table
        :headers="headers"
        :items="transactions"
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="state.pagination"
        :total-items = "state.pagination.totalItems"
        must-sort
        disable-initial-sort
        @update:pagination="onUpdatePagination"
        class="elevation-1 mt-3 no-row-highlight"
      >

        <template slot="headerCell" slot-scope="props">
          <template v-if="props.header.value === 'transactionnum'" class="qwerty">
            <span class="filter-column-text">{{ $t(props.header.text) }}</span>
            <v-edit-dialog
              ref="filter-transactionnum"
              lazy
              :class="'filter-column-editor' + (state.filter ? ' active' : '')"
            >
              <v-icon class="ml-1 mr-1" @click.stop="onSearchClick">search</v-icon>
              <v-text-field
                slot="input"
                v-model="state.filter"
                :label="$t('Common.filterText')"
                clearable
                single-line
                @change="onFilterChanged"
              ></v-text-field>
            </v-edit-dialog>
          </template>

          <span v-else>{{ $t(props.header.text) }}</span>
        </template>

        <template slot="items" slot-scope="props">
          <tr @click="openDetails(props.item)">
          <td
            v-for="header in headers.filter(x=>!x.default)"
           :key="header.value"
           :class="header.align ? 'text-xs-' + header.align : undefined"
          >
            {{getTransactionValue(props.item, header, $i18n.locale)}}
          </td>

          <td class="text-xs-center">
            <v-btn :flat="true" color="info" @click.stop="printTransaction(props.item)" small style="min-width: 40px">
              <v-icon>{{ props.item.printing ? 'fas fa-circle-notch fa-spin' : 'print'}}</v-icon>
            </v-btn>
          </td>
          <td class="text-xs-center" v-if="showAddToCart">
            <v-btn :flat="true" color="info" @click.stop="duplicate(props.item)" small style="min-width: 40px">
              <v-icon>{{ props.item.cloning ? 'fas fa-circle-notch fa-spin' : 'fas fa-cart-plus'}}</v-icon>
            </v-btn>
          </td>
          </tr>
        </template>

      </v-data-table>
    </v-container>
  </div>
</template>

<script>
  import store from '../store'
  import { saveAs } from 'file-saver'

  const TYPE_ORDERS = 'orders'
  const TYPE_BILLING = 'billing'
  const TYPE_QUOTES = 'quotes'
  const TYPE_DELIVERIES = 'deliveries'

  export default {
    name: 'Transactions',
    props: {
      config: Object,
    },
    mounted() {
      this.closeDetails = this.closeDetails.bind(this);
    },
    computed: {
      type() {
        switch(this.config.type) {
          case TYPE_QUOTES: return 0;
          case TYPE_ORDERS: return 1;
          case TYPE_DELIVERIES: return 2;
          case TYPE_BILLING: return 3;
          default:
            throw new Error(`Transaction.vue ERROR! ${this.config.type} is invalid transaction type`)
        }
      },
      state() {
        if (!store[this.config.type]) {
          store[this.config.type] = {
            pagination: {},
            filter: ''
          };
        }
        return store[this.config.type];
      },
    },
    data() {
      const headers = [];
      const sourceMapper = {};
      const showAddToCart = this.config.type === TYPE_ORDERS;

      if (this.config.columns) {
        this.config.columns.forEach(col => {
          let value = col.field;
          value = Array.isArray(value) ? value.join('__') : value;
          value = value.replace('.', '');
          headers.push({
            text: col.label,
            value,
            sortable: col.sortable,
            align: col.align,
            width: col.width,
            type: col.type,
          });
          const key = JSON.stringify(Array.isArray(col.field) ? col.field: [col.field]);
          sourceMapper[key] = value;
        });

        headers.push({
          text: 'Action.print',
          value: 'print',
          sortable: false,
          align: 'center',
          width: '40px',
          default: true,
        });

        showAddToCart && headers.push({
          text: 'Action.addToCart',
          value: 'fas fa-cart-plus',
          sortable: false,
          align: 'center',
          width: '40px',
          default: true,
        });
      }

      return {
        headers,
        cartHeaders: [
          {text: 'Common.itemNum', value: 'itemnum', align: 'left'},
          {text: 'Common.itemName', value: 'name', align: 'left'},
          {text: 'Common.quantity', value: 'amount', align: 'center', width: '100px'},
          {text: 'Common.taxPercent', value: 'taxrate', align: 'right'},
          {text: 'Common.itemPrice', value: 'sellingprice', align: 'right'},
          {text: 'Common.total', value: 'nettotal', align: 'right'},
        ],
        sourceMapper,
        showAddToCart,
        rowsPerPageItems: [6, 12, 24, { "text": "$vuetify.dataIterator.rowsPerPageAll", "value": -1 }],
        transactions: [],
        details: {visible: false, cart: null},
      };
    },
    methods: {
      refresh() {
        const params = {
          type: this.type,
          offset: (this.state.pagination.page || 1) - 1,
          limit: this.state.pagination.rowsPerPage
        };
        if (this.state.pagination.sortBy) {
          params['orderby'] = (this.state.pagination.descending ? '-' : '') + this.state.pagination.sortBy;
        }
        if (this.state.filter) {
          params['search'] = this.state.filter;
        }

        this.$http.get(this.$root.route('transactions'), {params}).then(
          response => {

            this.transactions = response.body.result.data.map(t => {
              let res = Object
                .keys(this.sourceMapper)
                .reduce((p, map) => {
                  const field = this.sourceMapper[map];
                  JSON.parse(map).reverse().forEach(c => {
                    let currentVal = t;
                    c.split('.').forEach((prop)=> {
                      if (currentVal !== null && currentVal !== undefined) {
                        currentVal = currentVal[prop];
                      }
                    });
                    if (currentVal) {
                      p[field] = currentVal;
                    }
                  });
                  return p;
                }, {});
              return { ...t, ...res, };
            });
            this.transactions.forEach(o => {
              o.total = Math.round((o.netamount + o.tax) * 1000000) / 1000000
            });
            this.state.pagination.totalItems = response.body.result.count;
          },
          response => {
            console.error('Fail', response);
          });
      },
      printTransaction(transaction) {
        transaction.printing = true;
        this.transactions = [...this.transactions];
        const params = { responseType: 'arraybuffer' }; // or { responseType: 'blob' }
        this.$http.get(this.$root.route('transaction/' + transaction.ID + '/print'), params).then(
          response => {
            const blob = new Blob([response.body], {type: "text/pdf;charset=utf-8"}); // or {type: 'application/pdf'}
            saveAs(blob, `${transaction.transactionnum}.pdf`);
            delete transaction.printing;
            this.transactions = [...this.transactions];
          },
          response => {
            console.error('Fail', response);
          });
      },
      onUpdatePagination(paginationObject) {
        Object.keys(paginationObject).forEach(key => this.state.pagination[key] = paginationObject[key]);
        this.refresh()
      },
      onFilterChanged() {
        this.$refs['filter-transactionnum'].isActive = false;
        this.refresh();
      },
      onSearchClick() {
        this.$refs['filter-transactionnum'].isActive = true;
      },
      getTransactionValue(ticket, header, i18Locale) {
        const res = ticket[header.value];
        if (header.type === 'num') {
          return res.toLocaleString(i18Locale, {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }
        if (header.type === 'date') {
          return !res ? '-' : new Date(res * 1000).toLocaleDateString(
            i18Locale, {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            });
        }
        return res;
      },
      duplicate(transaction) {
        transaction.cloning = true;
        this.transactions = [
          ...this.transactions,
        ]

        this.$http.get(this.$root.route('transaction/' + transaction.ID + ''))
          .then(({body}) => {
            delete transaction.cloning;
            this.transactions = [
              ...this.transactions,
            ]
            const items = {};
            body.result.cart.items.forEach(({itemnum, amount}) => {
              items[itemnum] = amount;
            });

            this.$root.globalComponent.addToCart(items);
          });
      },

        setFilter(value) {
        this.state.filter = value;
        this.refresh();
      },
      openDetails(transaction) {
        this.$http.get(this.$root.route('transaction/' + transaction.ID + ''))
          .then(({body}) => {
            console.log('body', body);
            this.details = {
              items: {},
              ...body.result,
              visible: true,
            };

            history.pushState(null, document.title, location.href);
            window.addEventListener('popstate', this.closeDetails);
          });

        return false;
      },
      closeDetails() {
        this.details = {
          ...this.details,
          visible: false,
        };

        window.removeEventListener('popstate', this.closeDetails);
      }
    }
  }
</script>

<style lang="scss">
  .no-row-highlight tbody {
    tr:hover {
      background-color: transparent !important;
      cursor: default;
    }
  }
  .filter-column-editor + i {
    float: left;
    margin-left: 6px;
  }
</style>

<style lang="scss" scoped>
  .filter-column-editor {
    display: inline-block !important;
    width: 20px !important;
  }
  .filter-column-editor.active i {
    opacity: 1 !important;
  }
  .filter-column-editor i {
    transform: none !important;
    color: white !important;
    opacity: 0.5 !important;
  }
  span.filter-column-text {
    float: left;
  }
</style>
